import { Show } from 'solid-js'

import { useI18n } from '../../i18n'
import Button from '../ui/Button'

type EditModalFooterProps = {
   /** Validation error to show above the buttons; empty hides it. */
   error: string
   saveId: string
   cancelId: string
   onSave: () => void
   onCancel: () => void
   /** Deletes the entry being edited; omitted hides the Delete button. */
   onDelete?: () => void
   deleteId?: string
   /** Delete button text (defaults to "Delete"). */
   deleteLabel?: string
}

/**
 * Renders the shared error line, Save/Cancel row and optional Delete button used by the
 * edit modals (laid out like the habit edit modal).
 *
 * @param props - The footer props.
 * @returns The footer element.
 */
const EditModalFooter = (props: EditModalFooterProps) => {
   const t = useI18n()

   return (
      <>
         <Show when={props.error}>
            <p class="text-sm text-rose-200">{props.error}</p>
         </Show>
         <div class="mt-4 grid gap-3">
            <div class="flex gap-4">
               <Button id={props.saveId} class="flex-1" onClick={props.onSave}>
                  {t('Save')}
               </Button>
               <Button
                  id={props.cancelId}
                  variant="secondary"
                  class="flex-1"
                  onClick={props.onCancel}
               >
                  {t('Cancel')}
               </Button>
            </div>
            <Show when={props.onDelete}>
               {onDelete => (
                  <Button
                     id={props.deleteId}
                     variant="danger"
                     onClick={() => onDelete()()}
                  >
                     {props.deleteLabel ?? t('Delete')}
                  </Button>
               )}
            </Show>
         </div>
      </>
   )
}

export default EditModalFooter
